import { Button } from "PFComponents/button";
import { Stack } from "PFComponents/containers";
import { Icon } from "PFComponents/icon";
import { Typography } from "PFComponents/typography";
import { useTranslation } from "react-i18next";

import css from "../skills_section.module.scss";
import { SkillsViewCommonProps } from "../skills_section.types";

type SkillsEmptyStateProps = Pick<SkillsViewCommonProps, "searchTerm" | "setSearchTerm">;

export const SkillsEmptyState = ({ searchTerm, setSearchTerm }: SkillsEmptyStateProps) => {
  const { t } = useTranslation("profiles", { keyPrefix: "show.parts.skillsSection" });

  return (
    <Stack alignItems="center" className={css.emptyState}>
      <Icon name="missing" color="paletteBlue2" />
      <Typography variant="labelRegular" className={css.text}>
        {t("noSkillsFound")}
      </Typography>
      {!!searchTerm && (
        <Button text={t("clearSearch")} icon="filter-clean" onClick={() => setSearchTerm("")} />
      )}
    </Stack>
  );
};
